import { forwardRef } from "react";
import * as React from "react";
import { createBemBlockBuilder } from "@ebsco-ui/utils";
import cn from "classnames";
import IndeterminateSpinner from "@ebsco-ui/indeterminate-spinner";

import "./loading.scss";

export interface LoadingProps extends React.HTMLAttributes<HTMLDivElement> {
  direction?: "horizontal" | "vertical";
  loadingMessage: string;
  showMessage?: boolean;
  size?: "small" | "large";
}

const Loading = forwardRef<HTMLDivElement, LoadingProps>(
  (
    {
      className,
      direction = "vertical",
      loadingMessage,
      showMessage = true,
      size = "large",
      ...rest
    },
    ref,
  ) => {
    const getBlocksWith = createBemBlockBuilder(["eb-loading", className]);
    return (
      <div
        className={cn(
          getBlocksWith(),
          getBlocksWith(`--${direction}`),
          getBlocksWith(`--${size}`),
        )}
        role="status"
        aria-live="polite"
        aria-label={loadingMessage}
        ref={ref}
        tabIndex={-1}
        {...rest}
      >
        <IndeterminateSpinner
          className={getBlocksWith("__spinner")}
          level={size === "small" ? "component" : "page"}
        />
        {showMessage && (
          <p className={getBlocksWith("__message")}>{loadingMessage}</p>
        )}
      </div>
    );
  },
);

Loading.displayName = "Loading";

export default Loading;
